import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StrategyService } from '../services/strategy.service';
import { Observable } from 'rxjs';
import { Strategy } from '../interfaces/models/strategy.model';

export const listStrategiesResolver: ResolveFn<Observable<Strategy[]>> = (route, state) => {
  const strategyService = inject(StrategyService);
  return strategyService.RawStrategies$;
};
